import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const EvokePillars = () => {
  const { language } = useLanguage();
  
  const pillars = [
    {
      number: 1,
      title: language === 'es' ? 'Narrativa' : 'Narrative',
      description: language === 'es' ? 'Lo que significa el momento.' : 'What the moment means.'
    },
    {
      number: 2,
      title: language === 'es' ? 'Dirección Visual' : 'Visual Direction',
      description: language === 'es' ? 'Cómo se ve en todas partes.' : 'How it looks everywhere.'
    },
    {
      number: 3,
      title: language === 'es' ? 'Detalle Sensorial' : 'Sensory Detail',
      description: language === 'es' ? 'Cómo se siente.' : 'How it feels.'
    },
    {
      number: 4,
      title: language === 'es' ? 'Flujo' : 'Flow',
      description: language === 'es' ? 'Cómo se mueve.' : 'How it moves.'
    },
    {
      number: 5,
      title: language === 'es' ? 'Ejecución' : 'Execution',
      description: language === 'es' ? 'Cómo aterriza.' : 'How it lands.'
    }
  ];

  return (
    <section className="py-24 md:py-32 bg-vainilla" data-testid="evoke-pillars">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Title - Editorial Style */}
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-stone-900 text-center mb-20 italic">
          The Evoke Pillars
        </h2>

        {/* Pillars Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-6">
          {pillars.map((pillar) => (
            <div 
              key={pillar.number}
              className="flex flex-col items-center text-center group"
              data-testid={`pillar-${pillar.number}`}
            >
              {/* Oval Number Badge */}
              <div className="w-16 h-20 md:w-20 md:h-24 bg-stone-900 rounded-[50%] flex items-center justify-center mb-6 group-hover:bg-terracota transition-colors duration-300 shadow-lg">
                <span className="text-white font-serif text-2xl md:text-3xl italic">
                  {pillar.number}
                </span>
              </div>

              {/* Pillar Title - Italic Serif */}
              <h3 className="font-serif text-xl md:text-2xl text-stone-900 italic mb-2">
                {pillar.title}
              </h3>

              {/* Description */}
              <p className="text-stone-500 text-sm md:text-base">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EvokePillars;
